
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/api-access",
      function () {
        return require("private-next-pages/api-access/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/api-access"])
      });
    }
  